// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/alert_rule.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ConditionMatchType } from "./condition_match_type_pb";
import { file_inventory_v1_condition_match_type } from "./condition_match_type_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/alert_rule.proto.
 */
export const file_inventory_v1_alert_rule: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_inventory_v1_condition_match_type, file_inventory_v1_risk]);

/**
 * Rule is the row shape ListAlertRules / GetAlertRule return for the rules
 * table. Conditions live alongside (on GetAlertRuleResponse), not embedded —
 * the table never reads them and the editor catalog is per-signal-type, not
 * per-rule.
 *
 * @generated from message inventory.v1.Rule
 */
export type Rule = Message<"inventory.v1.Rule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string signal_type_name = 3;
   */
  signalTypeName: string;

  /**
   * @generated from field: string signal_type_id = 4;
   */
  signalTypeId: string;

  /**
   * @generated from field: inventory.v1.AlertRuleSeverity severity = 5;
   */
  severity: AlertRuleSeverity;

  /**
   * @generated from field: int32 alert_count_last_30_days = 6;
   */
  alertCountLast30Days: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: bool is_enabled = 8;
   */
  isEnabled: boolean;

  /**
   * @generated from field: bool is_ai_governance = 9;
   */
  isAiGovernance: boolean;
};

/**
 * Describes the message inventory.v1.Rule.
 * Use `create(RuleSchema)` to create a new message.
 */
export const RuleSchema: GenMessage<Rule> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 0);

/**
 * CustomFieldConditionsGroup is one AND-group of custom-field conditions.
 * Groups are joined by AND; conditions within a group are joined by OR.
 *
 * @generated from message inventory.v1.CustomFieldConditionsGroup
 */
export type CustomFieldConditionsGroup = Message<"inventory.v1.CustomFieldConditionsGroup"> & {
  /**
   * @generated from field: repeated inventory.v1.CustomFieldCondition custom_field_conditions = 1;
   */
  customFieldConditions: CustomFieldCondition[];
};

/**
 * Describes the message inventory.v1.CustomFieldConditionsGroup.
 * Use `create(CustomFieldConditionsGroupSchema)` to create a new message.
 */
export const CustomFieldConditionsGroupSchema: GenMessage<CustomFieldConditionsGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 1);

/**
 * CustomFieldCondition matches against an org_custom_field on the signal's
 * parent OrgCompany. selected_option_ids are option ids defined on the
 * custom field (resolved via CustomFieldService).
 *
 * @generated from message inventory.v1.CustomFieldCondition
 */
export type CustomFieldCondition = Message<"inventory.v1.CustomFieldCondition"> & {
  /**
   * @generated from field: inventory.v1.ConditionMatchType match_type = 1;
   */
  matchType: ConditionMatchType;

  /**
   * @generated from field: string custom_field_id = 2;
   */
  customFieldId: string;

  /**
   * @generated from field: repeated string selected_option_ids = 3;
   */
  selectedOptionIds: string[];
};

/**
 * Describes the message inventory.v1.CustomFieldCondition.
 * Use `create(CustomFieldConditionSchema)` to create a new message.
 */
export const CustomFieldConditionSchema: GenMessage<CustomFieldCondition> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 2);

/**
 * AlertCondition matches against a signal-type-scoped question's selected
 * answers. question_id refers to a SignalQuestion returned from
 * ListSignalTypes; selected_answer_ids refer to that question's options.
 *
 * @generated from message inventory.v1.AlertCondition
 */
export type AlertCondition = Message<"inventory.v1.AlertCondition"> & {
  /**
   * Required for multi-select questions; ignored for single-select questions.
   *
   * @generated from field: optional inventory.v1.ConditionMatchType match_type = 1;
   */
  matchType?: ConditionMatchType;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: repeated string selected_answer_ids = 3;
   */
  selectedAnswerIds: string[];
};

/**
 * Describes the message inventory.v1.AlertCondition.
 * Use `create(AlertConditionSchema)` to create a new message.
 */
export const AlertConditionSchema: GenMessage<AlertCondition> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 3);

/**
 * ThirdPartyInherentRiskQuestion is the rule's filter on the parent
 * company's inherent-risk severity. Independent of the signal-type-scoped
 * AlertConditions.
 *
 * @generated from message inventory.v1.ThirdPartyInherentRiskQuestion
 */
export type ThirdPartyInherentRiskQuestion = Message<"inventory.v1.ThirdPartyInherentRiskQuestion"> & {
  /**
   * @generated from field: repeated inventory.v1.RiskLevel severities = 1;
   */
  severities: RiskLevel[];

  /**
   * @generated from field: inventory.v1.ConditionMatchType match_type = 2;
   */
  matchType: ConditionMatchType;
};

/**
 * Describes the message inventory.v1.ThirdPartyInherentRiskQuestion.
 * Use `create(ThirdPartyInherentRiskQuestionSchema)` to create a new message.
 */
export const ThirdPartyInherentRiskQuestionSchema: GenMessage<ThirdPartyInherentRiskQuestion> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 4);

/**
 * SignalTypeOption is one entry in the rule editor's signal-type catalog.
 * Returned by ListSignalTypes. The `questions` list is the source of truth
 * for which AlertConditions the editor offers when this signal type is
 * selected.
 *
 * @generated from message inventory.v1.SignalTypeOption
 */
export type SignalTypeOption = Message<"inventory.v1.SignalTypeOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated inventory.v1.SignalQuestion questions = 3;
   */
  questions: SignalQuestion[];

  /**
   * The type's signals always carry their own severity, so its rules may use PASSTHROUGH.
   *
   * @generated from field: bool supports_passthrough_severity = 4;
   */
  supportsPassthroughSeverity: boolean;

  /**
   * @generated from field: bool is_ai_governance = 5;
   */
  isAiGovernance: boolean;
};

/**
 * Describes the message inventory.v1.SignalTypeOption.
 * Use `create(SignalTypeOptionSchema)` to create a new message.
 */
export const SignalTypeOptionSchema: GenMessage<SignalTypeOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 5);

/**
 * SignalQuestion is one question the rule editor offers under a signal type.
 * The editor renders a select control populated from `options`; when
 * is_single_select is false it also renders a match-type toggle
 * (INCLUDES / EXCLUDES) bound to AlertCondition.match_type.
 *
 * @generated from message inventory.v1.SignalQuestion
 */
export type SignalQuestion = Message<"inventory.v1.SignalQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: repeated inventory.v1.SignalQuestionOption options = 3;
   */
  options: SignalQuestionOption[];

  /**
   * @generated from field: bool is_single_select = 4;
   */
  isSingleSelect: boolean;
};

/**
 * Describes the message inventory.v1.SignalQuestion.
 * Use `create(SignalQuestionSchema)` to create a new message.
 */
export const SignalQuestionSchema: GenMessage<SignalQuestion> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 6);

/**
 * @generated from message inventory.v1.SignalQuestionOption
 */
export type SignalQuestionOption = Message<"inventory.v1.SignalQuestionOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message inventory.v1.SignalQuestionOption.
 * Use `create(SignalQuestionOptionSchema)` to create a new message.
 */
export const SignalQuestionOptionSchema: GenMessage<SignalQuestionOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rule, 7);

/**
 * AlertRuleSeverity is the severity a rule gives the alerts it creates. PASSTHROUGH keeps the
 * signal's own severity (OrgSignal.IntrinsicSeverity).
 *
 * @generated from enum inventory.v1.AlertRuleSeverity
 */
export enum AlertRuleSeverity {
  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_HIGH = 3;
   */
  HIGH = 3,

  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_CRITICAL = 4;
   */
  CRITICAL = 4,

  /**
   * @generated from enum value: ALERT_RULE_SEVERITY_PASSTHROUGH = 5;
   */
  PASSTHROUGH = 5,
}

/**
 * Describes the enum inventory.v1.AlertRuleSeverity.
 */
export const AlertRuleSeveritySchema: GenEnum<AlertRuleSeverity> = /*@__PURE__*/
  enumDesc(file_inventory_v1_alert_rule, 0);

